import "./src/styles/global.css";
import * as React from "react";
import { ContentProvider } from "./src/lib/content-overrides";

export const wrapRootElement = ({ element }) => (
  <ContentProvider
    clientSlug="elektro-de-waele"
    apiUrl={process.env.GATSBY_CONTENT_API_URL}
  >
    {element}
  </ContentProvider>
);
